"use client";

import AnnounSection from "@/components/sections/landing-page/announSection";
import AppSection from "@/components/sections/landing-page/appSection";
import FaqSection from "@/components/sections/landing-page/faqSection";
import Hero from "@/components/sections/landing-page/heroSection";
import MapSection from "@/components/sections/landing-page/mapSection";
import NewsSection from "@/components/sections/landing-page/newsSection";
import SkmSection from "@/components/sections/landing-page/skmSection";

export default function Home() {
  return (
    <div className="flex gap-10 min-h-screen flex-col">
      <Hero />
      <AppSection />
      <MapSection />
      <SkmSection />
      <AnnounSection />
      <NewsSection />
      <FaqSection />
      {/* <Contact /> */}
    </div>
  );
}
